module.exports = __webpack_public_path__ + "media/images/api-082c06b8cbb08f92fefc319d97ac061a.svg";